/**
 * Home-content entry point to the Explore hub. The header carries no product
 * nav (decision of 26/08: Explore lives in the home content, not the top
 * bar), so this banner is the primary way into `/explorar`.
 */

import { useNavigate } from 'react-router-dom'
import { analyticsService, useComponentImpression } from '@meiuca/analytics'
import { Body, H3 } from '@meiuca/ui-components'
import { ChevronRight, Compass } from 'lucide-react'
import { ANALYTICS_EVENTS, COMPONENT_TYPES } from '@/constants/analyticsEvents'

export function ExploreBanner() {
  const navigate = useNavigate()

  const impressionRef = useComponentImpression({
    componentType: COMPONENT_TYPES.EXPLORE_BANNER,
    componentKey: 'home-explore-banner'
  })

  return (
    <div ref={impressionRef} className="max-w-7xl mx-auto px-4 py-6">
      <button
        onClick={() => {
          analyticsService.track(ANALYTICS_EVENTS.EXPLORE_BANNER_CLICKED)
          navigate('/explorar')
        }}
        className="flex w-full items-center gap-4 rounded-xl border border-border-light bg-background-white p-5 text-left transition-shadow hover:shadow-md"
      >
        <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-brand-primary/10">
          <Compass className="h-6 w-6 text-brand-primary" />
        </span>
        <span className="flex-1 min-w-0">
          <H3 className="text-text-primary text-base">Explorar</H3>
          <Body className="text-sm text-text-secondary">
            Arenas, centros de treinamento, day use e torneios perto de você.
          </Body>
        </span>
        <ChevronRight className="h-5 w-5 flex-shrink-0 text-text-tertiary" />
      </button>
    </div>
  )
}
